import documentApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleDocuments';

type ThisApi = ApiDefinition['/document-requests/{id}']['DELETE'];
type Input = ThisApi['params'];

const archiveDocumentRequest = async ({ id }: Input): Promise<ThisApi['response']> => {
  const response = await documentApiClient.delete(`/document-requests/${id}`);
  return response.data;
};

export default archiveDocumentRequest;
